import React from 'react'
import { Button, Container, Row, Card, Col, Tabs, Tab } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styles from './Measures.module.scss';
import { data } from '../data';

const PDIResources = () => {

    return (<>
        <Container className='outerContainer'>
            <h1 className="centerText mb-5">Pediatric Quality Indicators Overview</h1>
            <div className='mb-5'>
                <h3>What are Pediatric Quality Indicators?</h3>
                <p>The Pediatric Quality Indicators (PDIs) focus on potentially preventable complications and iatrogenic events for pediatric patients treated in hospitals and on preventable hospitalizations among pediatric patients, taking into account the special characteristics of the pediatric population.</p>
            </div>
            <div className='mb-5'>
                <h3>How are Pediatric Quality Indicators used?</h3>
                <p>The PDIs can be used to identify potential quality and patient safety issues specific to the pediatric inpatient population. They can help hospitals identify problems in pediatric hospital care that may need further study and evaluate preventive care for children in outpatient settings.</p>
            </div>
            <p>For more information about the Pediatric Quality Indicators, download the <a href='https://www.qualityindicators.ahrq.gov/Downloads/Modules/PDI/V50/Pediatric_Ind.pdf'>Pediatric Quality Indicators Brochure</a>.</p>
        </Container>
        <Container className='outerContainer'>
            <h3 className="centerText mb-5">Pediatric Quality Indicators Resources</h3>
            {data.PDI.map((information, index) => (
                <div key={index}>
                    <Tabs defaultActiveKey="technical" className={'qiTabs'}>
                        <Tab id="techspecs" eventKey="technical" title="Technical Specifications">
                            <Container className='outerContainer'>
                                <Row>
                                    {information.technical && information.technical.map(info => (
                                        <Col className={styles.columns} xs={12} sm={6} md={4}>
                                            <Card className={styles.cards}>
                                                <Card.Header className={styles.cardHeader} >
                                                    <a href={info.url}><h5>{info.title}</h5></a>
                                                </Card.Header>
                                                <Card.Body className={styles.lightGrey}>
                                                    <Card.Text>
                                                        {info.desc}
                                                        {info.status === "new" ? <span class='new-label'> -New!</span> :null}

                                                    </Card.Text>
                                                </Card.Body>
                                                <div className={'p-2 centerText' + ' ' + styles.lightGrey} >
                                                    <Button className={styles.ctaBtn} href={info.url}>{info.cta}</Button>
                                                </div>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </Container>

                        </Tab>
                        <Tab eventKey="additional" title="Additional PDI Resources">
                            <Container className='outerContainer'>
                                <Row>
                                    {information.additional && information.additional.map(info => (<>
                                        <Col className={styles.columns} xs={12} sm={6} md={4}>
                                            <Card className={styles.cards}>
                                                <Card.Header className={styles.cardHeader} >
                                                    <a href={info.url}><h5>{info.title}</h5></a>
                                                </Card.Header>
                                                <Card.Body className={styles.lightGrey}>
                                                    <Card.Text>
                                                        <div dangerouslySetInnerHTML={{ __html: info.desc }} />
                                                    </Card.Text>
                                                </Card.Body>
                                                <div className={'p-2 centerText' + ' ' + styles.lightGrey} >
                                                    <Button className={styles.ctaBtn} href={info.url}>View</Button>
                                                </div>
                                            </Card>
                                        </Col>
                                    </>)
                                    )}
                                </Row>

                            </Container>
                        </Tab>

                    </Tabs>
                    <p>To access prior versions of the PDI resources, visit the <Link to="/archive/qi_modules?4#PDI-TechSpec">Archives page</Link></p>

                </div>
            )
            )}
        </Container>
        <Container className='outerContainer'>
            <h3>Quality Indicator Software</h3>
            <p>Visit the  <Link to="/software">AHRQ QI Software Page</Link>  for more information on the Quality Indicators SAS QI and WinQI software.</p>
        </Container>
    </>)
}

export default PDIResources;